var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18 18",
    style: {
      enableBackground: "new 0 0 18 18"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#616161;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M9,3.4c-0.5,0-0.9,0.4-0.9,0.9L8.3,11c0,0.4,0.3,0.7,0.7,0.7s0.7-0.3,0.7-0.7l0.2-6.7C9.9,3.8,9.5,3.4,9,3.4z  M9,12.4c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1C10.1,12.9,9.6,12.4,9,12.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M11.3,18H6.7c-0.9,0-1.7-0.3-2.4-1L1,13.7c-0.6-0.6-1-1.5-1-2.4V6.7c0-0.9,0.3-1.7,1-2.4L4.3,1 c0.6-0.6,1.5-1,2.4-1h4.7c0.9,0,1.8,0.4,2.4,1L17,4.3c0.6,0.6,1,1.5,1,2.4v4.7c0,0.9-0.3,1.7-1,2.4L13.7,17 C13.1,17.7,12.2,18,11.3,18L11.3,18z M6.7,1.1c-0.6,0-1.2,0.2-1.6,0.7L1.8,5.1c-0.4,0.4-0.7,1-0.7,1.6v4.7c0,0.6,0.2,1.2,0.7,1.6 l3.3,3.3c0.4,0.4,1,0.7,1.6,0.7h4.7c0.6,0,1.2-0.2,1.6-0.7l3.3-3.3c0.4-0.4,0.7-1,0.7-1.6V6.7c0-0.6-0.2-1.2-0.7-1.6l-3.3-3.3 c-0.4-0.4-1-0.7-1.6-0.7L6.7,1.1L6.7,1.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReportIcon);
export default __webpack_public_path__ + "static/media/reportIcon.370557b3a370f827ec7ba6e2a1110f74.svg";
export { ForwardRef as ReactComponent };